// Subtitles show one sentence at a time. The narration clips carry no word
// timings, so each sentence is given a share of the clip in proportion to its
// length (plus a small beat for the pause after it), which tracks the spoken
// pace closely enough that the line on screen is the one being said.

const MAX_LINE = 110;

/** Split narration into caption lines: sentences, with long ones broken at ":" or ";". */
export function captionLines(text: string): string[] {
  const sentences = text.match(/[^.!?]+(?:[.!?]+["')\]]*|$)/g)?.map((s) => s.trim()).filter(Boolean) ?? [text];
  const lines: string[] = [];
  for (const s of sentences) {
    if (s.length <= MAX_LINE) {
      lines.push(s);
      continue;
    }
    const parts = s.split(/(?<=[:;])\s+/);
    lines.push(...parts.map((p) => p.trim()).filter(Boolean));
  }
  return lines;
}

/** The line to show `positionMs` into a clip that lasts `durationMs`. */
export function captionAt(text: string, positionMs: number, durationMs: number): string {
  const lines = captionLines(text);
  if (lines.length <= 1 || !(durationMs > 0)) return lines[0] ?? text;
  const BEAT = 6; // characters' worth of pause after each line
  const weights = lines.map((l) => l.length + BEAT);
  const total = weights.reduce((a, b) => a + b, 0);
  const at = Math.min(0.9999, Math.max(0, positionMs / durationMs)) * total;
  let acc = 0;
  for (let i = 0; i < lines.length; i++) {
    acc += weights[i];
    if (at < acc) return lines[i];
  }
  return lines[lines.length - 1];
}
